var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 mb-2 kath-sz-card link",on:{"click":function($event){$event.stopPropagation();return _vm.openFile(_vm.Mitgliederliste.file)}}},[_vm._v(" "+_vm._s(_vm.Mitgliederliste.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }